// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VehicleQuotationPayloadAPIModel from "../api-model/VehicleQuotationPayloadAPIModel.bs.js";

var execute = VehicleQuotationPayloadAPIModel.t_encode;

export {
  execute ,
  
}
/* No side effect */
